export const questionnaireEvaluationDataSource = (state) => state.domain.questionnaireEvaluation;
//# sourceMappingURL=questionnaireEvaluationDataSource.js.map